import React from 'react';

/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  useSrpz,
  gs,
  a,
  l,
  f,
  BoxC,
  BtnC,
  GridC,
  TextC,
  _cv_31___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as ihd from './ihd';

//let $_31rs = [] as ht.ls;

export const O = (pz: {
  sPz: ht.dz,
  cz: {
    _31rs?: ht.ls,
  }
}) => {

  const _frcUdt = ls.frcUdt();
  const _gStgz = gs.useStgz();

  const _ls2 = pz.cz._31rs?.map( (__31rz: ht.dz, _nIdx: ht.n) => {
    const __50rz = hf.cvtLsToDz(__31rz.cldz._50rs, (_dz: ht.dz) => _dz._icn);
    const __51rz = hf.cvtLsToDz(__31rz.cldz._51rs, (_dz: ht.dz) => _dz._icn);
    const __51rz2 = {
      ... __50rz,
      ... __51rz,
    };
    const _51ra1100t = __51rz2.S07010212._51ra1100t ?? __51rz2.S07010212._50ra1100t;
    const _i1zrs = __31rz.cldz.i1zrs;
    return (
      cr.c(BoxC.N, {
        key: _nIdx,
        boxStlz: a('bc/lt9 bwv/2 dw/f mv/1'),
        oClds: [

          cr.c(BoxC.N, {
            key: -10,
            boxStlz: 
              cr.d('p') ?
                // a(`dw/f fd/rcc pv/0.5 mb/1 sc/${pz.sPz.crt.dffz.clr}3`)
                a(`dw/f fd/rbc pv/0.5 mb/1 sc/${pz.sPz.crt.dffz.clr}3`)
              : a(`dw/f fd/csc pb/1.0 mb/1 sc/${pz.sPz.crt.dffz.clr}3`),
            oClds: [

              cr.c(TextC.N, { // 施設名
                key: -10,
                boxStlz: 
                  cr.d('p') ?
                    a(`dw/38 fd/ccc p/1 mr/2`)
                  : a(`dw/38 fd/ccc p/1`),
                textz: {
                  pfx: __31rz._pfx,
                  stlz: a('tb ts/l'),
                },
              }),

/*
              cr.c(TextC.N, { // エントリー上限数
                key: -20,
                boxStlz: 
                  cr.d('p') ?
                    a(`dw/38 fd/ccc p/1 mr/1`)
                  : a(`dw/38 fd/ccc p/1`),
                textz: {
                  pfx: `${pz.sPz.crt.dffz.tgt}上限数：${_51ra1100t}`,
                  stlz: a('tb'),
                },
              }),
*/

              pz.sPz.crt.ctt == 'r' || 
              (pz.sPz.crt.ctt == 'e' && _gStgz.crt.bAlyPrd) ?
              cr.c(BtnC.N, { // 新規予約ボタン
                key: -30,
                abtType: 'rndDntz',
                boxStlz:
                  cr.d('p') ?
                    a(`dw/18 sc/${pz.sPz.crt.dffz.clr}5 mr/1`)
                  : a(`dw/18 sc/${pz.sPz.crt.dffz.clr}5`),
                lblCz: {
                  textz: {
                    pfx: `新規${pz.sPz.crt.dffz.tgt}`,
                    stlz: pz.sPz.crt.ctt == 'e' ? a(`tc/lt1`): undefined,
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    pz.sPz.set({
                      steps: [1, 0],
                      phs: 'crt',
                      _31rz: __31rz,
                      i191z: hf.get1(__31rz.cldz.i191s, {}),
                    });
                  },
                },
              })
              : undefined,

            ],
          }),

          cr.c(BoxC.N, {
            key: -20,
            boxStlz: a('dw/f fd/csc ph/1 mb/1 sc/lt1'),
            oClds: [

              cr.c(TextC.N, { // 予約内容
                key: -10,
                boxStlz: a('dw/f fd/ccc mb/0.5'),
                textz: {
                  pfx: `${pz.sPz.crt.dffz.tgt}内容`,
                  stlz: a('tb ts/l'),
                },
              }),

              hf.f(_i1zrs) ?
              _i1zrs.map( (_i1zrz: ht.dz, _nIdx: ht.n) => { // 予約項目

                const _drc = hfDTM.getDrcDay(hfDTM.getTdy(), _i1zrz.i1zrd3100s);

                const _i1z3z = _i1zrz.cldz.i1z3s[0];
                return (
                  cr.c(GridC.N, {
                    key: _nIdx,
                    abtType: 'nolineCmnz',
                    boxStlz: 
                      a('bc/lt9 bs/ds bwt/0.5 dw/f fd/css pv/1'), 
                    lineCs: [
                      {
                        boxStlz: 
                          cr.d('p') ?
                            undefined
                          : a(`fd/rbc`),
                        cellCs: [
                          {
                            boxStlz: a(`dw/24 f/n`),
                            oClds: [
                              cr.c(TextC.N, {
                                key: -10,
                                textz: {
                                  pfx: hfDTM.f(_i1zrz.i1zrd3100s, '年月日（曜）', false),
                                  stlz: a('tb'),
                                },
                              }),

                            ]
                          },
                          {
                            oClds: [
                              cr.c(TextC.N, {
                                key: -20,
                                textz: {
                                  pfx: `【${_i1zrz.i1zra1100s}】`,
                                  stlz: a('tb'),
                                },
                              }),

                            ]
                          },
                          cr.d('p') ?
                          {
                            boxStlz: a('f/2'),
                            oClds: [
                            ]
                          }
                          : null,
                        ]
                      },
                      {
                        boxStlz: 
                          cr.d('p') ?
                            undefined
                          : a(`f/n fw`),
                        cellCs: [
                          {
                            boxStlz: 
                              cr.d('p') ?
                                undefined
                              : a(`dh/4 dw/15 f/n`),
                            oClds: [
                              cr.c(TextC.N, {
                                key: -10,
                                textz: {
                                  pfx: `ID:${_i1zrz._icn}`,
                                },
                              }),
                            ]
                          },
                          {
                            boxStlz: 
                              cr.d('p') ?
                                undefined
                              : a(`dh/4 dw/25 f/n`),
                            oClds: [
                              cr.c(TextC.N, {
                                key: -10,
                                textz: {
                                  pfx: _i1zrz.i1zra1200s,
                                  ptyz: a('tn/1'),
                                },
                              }),
                            ]
                          },
                          pz.sPz.crt.ctt == 'e' ? 
                          {
                            boxStlz: 
                              cr.d('p') ?
                                undefined
                              : a(`dh/4 dw/40 f/n`),
                            oClds: [
                              cr.c(TextC.N, {
                                key: -5,
                                textz: {
                                  pfx: ihd.r(ihd.f('i1zrs1200i').ls, _i1zrz?.i1zrs1200i),
                                  stlz:a('tc/lt9'),
                                  ptyz: a('tn/1'),
                                },
                              }),
                            ]
                          }
                          : undefined,
                          {
                            boxStlz: 
                              cr.d('p') ?
                                a('dw/38 f/n fd/rbc')
                              : a('dh/4 dw/40 f/n fd/rbc'),
                            oClds: [

                              pz.sPz.crt.ctt == 'r' ? 
                              cr.c(TextC.N, {
                                key: -10,
                                textz: {
                                  pfx: '●' + ihd.r(ihd.f('i1z3s1100i').ls, _i1z3z?.i1z3s1100i),
                                  stlz: 
                                    _i1z3z?.i1z3s1100i == 20 ?
                                      a('tb tc/rd5 ts/xs')
                                    : a('tc/lt9 ts/xs'),
                                },
                              })
                              : null,

                              cr.c(TextC.N, {
                                key: -20,
                                textz: {
                                  pfx: 
                                    (pz.sPz.crt.ctt == 'r' && _drc < Number(_gStgz.crt.S06010212)) ||
                                    (pz.sPz.crt.ctt == 'r' && hf.i(_i1zrz.i1zrs1100i, [90])) ||
                                    (pz.sPz.crt.ctt == 'e' && hf.i(_i1zrz.i1zrs1200i, [80, 90])) 
                                    ?
                                      '●キャンセル不可'
                                    : '●キャンセル可',
                                  stlz: 
                                    (pz.sPz.crt.ctt == 'r' && _drc < Number(_gStgz.crt.S06010212)) ||
                                    (pz.sPz.crt.ctt == 'r' && hf.i(_i1zrz.i1zrs1100i, [90])) ||
                                    (pz.sPz.crt.ctt == 'e' && hf.i(_i1zrz.i1zrs1200i, [80, 90])) ?
                                      a('tb tc/rd5 ts/xs')
                                    : a('tc/lt9 ts/xs'),
                                },
                              }),

                              cr.c(BtnC.N, {
                                key: -30,
                                abtType: 'rndDntz',
                                boxStlz: a(`dw/18 sc/${pz.sPz.crt.dffz.clr}3`),
                                lblCz: {
                                  textz: {
                                    pfx:
                                      (pz.sPz.crt.ctt == 'r' && _drc < Number(_gStgz.crt.S06010212)) ||
                                      (pz.sPz.crt.ctt == 'r' && hf.i(_i1zrz.i1zrs1100i, [90])) ||
                                      (pz.sPz.crt.ctt == 'e' && hf.i(_i1zrz.i1zrs1200i, [80, 90])) ?
                                        '確認'
                                      : '確認・キャンセル',
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    pz.sPz.set({
                                      steps: [1, 3],
                                      phs: 'dpy',
                                      _31rz: __31rz,
                                      i191z: hf.get1(__31rz.cldz.i191s, {}),
                                      i1zr_fst: _i1zrz._fst,
                                    })
                                  }
                                },
                              })

                            ]
                          },
                        ]
                      }
                    ]
                  })
                )
              })
              :
              cr.c(TextC.N, {
                key: -20,
                boxStlz: a('bc/lt9 bs/ds bwt/0.5 dw/f fd/rsc pt/1'),
                textz: {
                  pfx: '予約なし',
                  stlz: a('mv/1'),
                },
              }),

            ]
          }),

        ]
      })
    );
  });

//  hf.l(`icvI1zDTo0 346: ${hf.s(pz.sPz.crt)}`);

  return (
    cr.c(BoxC.N, {
      key: -30,
      boxStlz: a(`sc/t`),
      abtType: 'mainAreaz',
      oClds: _ls2,
    })
  );
};
